import PhotoSwipe from 'photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';

document.addEventListener("DOMContentLoaded", function(event) {

    var pswpElement = document.querySelectorAll('.pswp')[0];

    // init items array for the following images
    var _galleryPictures = [];

    // init items array for the following images
    var _singlePictures = [];

    // find images and build items array
    $('.wp-block-gallery').find('a').each(function() {

        let _index = $('.wp-block-gallery a').index(this);

        let _path = $(this).attr('href');

        let tempImg = new Image();
        tempImg.src = _path;

        tempImg.addEventListener('load', function() {
            // push this image to the items array
            _galleryPictures.push({
                index: _index,
                values: {
                    src: _path,
                    w: tempImg.width,
                    h: tempImg.height
                }
            });
        });
    });

    // define options (if needed)
    var options = {
        index: 0, // start at first slide
        closeEl:true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        shareEl: true,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
    };

    // handle click on the images
    $('.wp-block-gallery').on('click', 'a', function(event, index) {

        // get index of image to start from
        let _linkIndex = $('article').find('.wp-block-gallery a').index(this);

        // disable click on link naturally
        event.preventDefault();

        // sort gallery by index key
        _galleryPictures.sort((a, b) => (a.index > b.index) ? 1 : -1);

        // create new array for the gallery
        let _tempPictures = [];
        _galleryPictures.forEach(function(_pictureEl) {
            // console.log(_pictureEl);
            _tempPictures.push(_pictureEl.values);
        });

        // Initializes and opens PhotoSwipe
        options.index = _linkIndex;
        let gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, _tempPictures, options);
        gallery.init();
    });

    // handle click on the images
    $('.wp-block-image').on('click', 'a', function(event, index) {

        // disable click on link naturally
        event.preventDefault();

        // get image path
        let _path = $(this).attr('href');

        // create temp image to get dimensions
        let tempImg = new Image();
        tempImg.src = _path;

        tempImg.addEventListener('load', function() {
            // Initializes and opens PhotoSwipe
            let psImage = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, [
                {
                    src : _path,
                    w   : tempImg.width,
                    h   : tempImg.height
                }
            ], options);

            // open
            psImage.init();
        });
    });

});
